import React from "react";

export const checkActive = ({isActive}) =>
  isActive ? "active" : "not-active";
